// extracted by mini-css-extract-plugin
export default {"open":"open_GO5z","socialMedias":"socialMedias_Id_J","logo":"logo_FF5Y","wrapper":"wrapper_EJU1","themeButton":"themeButton_LU9Q","light":"light_mGKg"};